






























































































































import { createComponent, ref, reactive, computed } from "@vue/composition-api";
import {
  BaseNumericKeyOnlyInput,
  BasePostCodeInput,
  BaseSingleSelect,
  BaseGenderItem,
  BasePrimaryButton,
  BaseFormLabel
} from "@web-components";
import DrinkingAgeModal from "@dcc/components/DrinkingAgeModal.vue";
import ProfilePostcodeToolTip from "@dcc/components/ProfilePostcodeToolTip.vue";
import GenericToolTip from "@dcc/components/GenericToolTip.vue";
import { useRouting } from "@dcc/compositions/useRouting";
import { useDictionary } from "@dcc/views/compositions/useDictionary";

import { findGetters } from "@dcc/store/profile/getters";
import { getActions } from "@dcc/store/profile/actions";
import { MIN_AGE, MAX_AGE, ALERT_AGE } from "@dcc/constants/ageConstants";
import { Gender } from "@dcc/types/gender";
// eslint-disable-next-line
import { ValidationState } from "./types/validationState";

export default createComponent({
  components: {
    BaseNumericKeyOnlyInput,
    DrinkingAgeModal,
    BaseFormLabel,
    BasePostCodeInput,
    BaseSingleSelect,
    BaseGenderItem,
    BasePrimaryButton,
    ProfilePostcodeToolTip,
    GenericToolTip
  },
  setup(props: {}, context) {
    const { handleNext, handlePrev } = useRouting(context);
    const dictionary = useDictionary();

    const { getAge, getGender, getPostcode } = findGetters(context.root.$store);

    const { updateProfile } = getActions(context.root.$store);
    const showModal = ref(false);

    const profile = reactive({
      age: getAge().value,
      gender: getGender().value,
      postcode: getPostcode().value
    });

    const validationState = reactive({
      age: false,
      postcode: false
    });

    const isFormValid = computed(
      () =>
        validationState.age &&
        validationState.postcode &&
        profile.gender !== undefined
    );

    const handleNextClicked = () => {
      updateProfile(profile);
      if (profile.age && profile.age < ALERT_AGE) {
        showModal.value = true;
      } else {
        handleNext();
      }
    };

    const handleAgeValidation = (value: ValidationState) => {
      validationState.age = value.valid;
    };

    const handlePostcodeValidation = (value: ValidationState) => {
      validationState.postcode = profile.postcode.length === 0 || value.valid;
    };

    return {
      profile,
      Gender,
      handleAgeValidation,
      handlePostcodeValidation,
      showModal,
      MIN_AGE,
      MAX_AGE,
      ALERT_AGE,
      validationState,
      handlePrev,
      handleNextClicked,
      isFormValid,
      ...dictionary
    };
  }
});
